exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-actions > .btn:not(:last-child) {\n    margin-right: .5rem;\n}", ""]);

// exports
